import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LongTextInput, translate as t } from 'admin-on-rest';
import { Field, change as onChange, getFormValues } from 'redux-form';
import equal from 'deep-equal';
import { get } from 'lodash';

import {
  Card,
  CardHeader,
  Tabs,
  Tab,
  Divider,
} from 'material-ui';
import Warning from 'material-ui/svg-icons/alert/warning';
import { orange500 } from 'material-ui/styles/colors';

import { compose } from 'recompose';
import RichTextInput from './RichTextInput';

const styles = {
  wrapper: { padding: '1em 0' },
  tabContent: { padding: '0.3em 1em 1em 1em' },
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  icon: { margin: '-2px 0 0 3px', width: '16px', height: '16px' },
  tabText: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
};

const locales = [
  { id: 'sv', name: 'Swedish' },
  { id: 'en', name: 'English' },
  { id: 'nb', name: 'Norwegian' },
  { id: 'da', name: 'Danish' },
  { id: 'fi', name: 'Finnish' },
  { id: 'de', name: 'German' },
  { id: 'es', name: 'Spanish' },
];

export class TranslatableInput extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount = () => {
    // this.hydrateMarkets(this.props);
    this.hydrateLanguages(this.props);
  }

  shouldComponentUpdate = ({ source, record }) => this.props.source.length < source.length || !equal(get(this.props.record, source), get(record, source));

  hydrateLanguages = ({ record, source, change }) => {
    const newRecord = { ...record };
    newRecord[source] = locales.map((locale) => {
      const val = get(record, source) ? get(record, source).find((item) => item.lang === locale.id) : { content: '' };
      return { lang: locale.id, content: val ? val.content : '' };
    });

    change('record-form', source, get(newRecord, source));
  };

  render() {
    const { source, translate, resource, record } = this.props;

    return (
      <div style={styles.wrapper}>
        <Card>
          <CardHeader title={translate(`resources.${resource}.fields.${source}`)} />
          <Divider />
          <Tabs>
            {locales.map((tab, index) =>
              (
                <Tab
                  key={tab.name}
                  label={
                    <span style={styles.tabText}>
                      <span>{tab.name}</span>
                      {get(record, `${source}[${index}].content`) ?
                        null
                        : <Warning style={styles.icon} color={orange500} />
                      }
                    </span>
                  }
                >
                  <div style={styles.tabContent}>
                    <InputType {...this.props} tab={tab} index={index} />
                  </div>
                </Tab>
              )
            )}
          </Tabs>
        </Card>
      </div>
    );
  }
}

const InputType = ({ multiline = false, source, index, options, tab, resource, translate, ...props }) => (
  <Field
    {...props}
    name={`${source}[${index}]`}
    component={multiline ? RichTextInput : LongTextInput}
    format={(title) => {
      if (!title) return '';
      if (typeof title === 'string') {
        return title;
      }
      return title.content ? title.content : '';
    }}
    parse={(content) => ({ lang: tab.id, content: content || '' })}
    // type="text"
    label={`${tab.name} ${translate(`resources.${resource}.fields.${source}`)}`}
  />
);

TranslatableInput.propTypes = {
  source: PropTypes.string,
  multiline: PropTypes.bool,
};

const selector = getFormValues('record-form');

const enhance = compose(
  t
);

export default connect((state) => ({ record: selector(state) }), { change: onChange })(enhance(TranslatableInput));
